import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export type PortalResource = 'dealers' | 'clients';

export interface PortalUser {
  id: number;
  email: string;
  fullName: string;
  status: string;
  lastLoginAt: string | null;
  createdAt: string;
  approverType?: 'ops' | 'finance' | null;
}

export interface AddPortalUserResult {
  email: string;
  temporaryPassword: string;
  userId: number;
}

/** Admin-managed login users mapped to a dealer/client (team members sharing the entity's access). */
export const teamUsersApi = {
  async list(resource: PortalResource, entityId: number): Promise<PortalUser[]> {
    return (await apiClient.get<ApiSuccess<PortalUser[]>>(`/${resource}/${entityId}/users`)).data.data;
  },
  async add(resource: PortalResource, entityId: number, body: { email: string; fullName?: string; password?: string; approverType?: 'ops' | 'finance' }): Promise<AddPortalUserResult> {
    return (await apiClient.post<ApiSuccess<AddPortalUserResult>>(`/${resource}/${entityId}/users`, body)).data.data;
  },
};
